import React, { useEffect, useContext } from "react";
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import { ValidSelect } from "beaktShared/helpers/validselect";

import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import InputAdornment from '@material-ui/core/InputAdornment';
import LoadingIcon from "@material-ui/icons/Cached";
import "beaktShared/components/CustomInput/rotate.css";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import { SessionContext, getSessionCookie } from "beaktShared/services/session";
import Select from 'react-select';
import Check from "@material-ui/icons/Check";
import { UsePostApi, UseGetApiSimple } from "beaktShared/services/crudeApiService";
import MaskedInput from 'react-text-mask';
import moment from "moment";
import CloseIcon from '@material-ui/icons/Close';
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import stylesHeader from "assets/jss/BeaktDay/views/agenda/headerAgendamentoRecorrente";
import { MaskDate, formateDate, validateDate, convertDate, MaskTime, MaskCPF } from "beaktShared/helpers/masks";
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(styles);
const useStylesHeader = makeStyles(stylesHeader);

export default function AgendamentoContrato({ closemodal, callback, showmodal }) {
    const { t } = useTranslation();
    const classes = useStyles();
    const classesHeader = useStylesHeader();

    const [session, setSession] = React.useState(useContext(SessionContext));

    const { register, handleSubmit, setValue, getValues, errors, clearError, setError } = useForm({ mode: "onChange" });
    const [profissional, setprofissional] = React.useState("");

    const [venda, setvenda] = React.useState("");
    const [listSelectProfissional, setlistSelectProfissional] = React.useState([]);
    const [servico, setservico] = React.useState("");
    const [qtdServico, setqtdServico] = React.useState(0);

    const [allservico, setallservico] = React.useState("");
    const [listSelectServico, setlistSelectServico] = React.useState([]);

    const [loading, setLoading] = React.useState(false);
    const [notification, setNotification] = React.useState(false);
    const [colorNotification, setColorNotification] = React.useState('info');
    const [mensagemNotification, setMensagemNotification] = React.useState(false);
    const showNotification = (mensagem, color) => {
        setMensagemNotification(mensagem);
        setColorNotification(color);
        setNotification(true);
        setTimeout(function () {
            setNotification(false);
        }, 60000);
    };

    const [etapa, setetapa] = React.useState(0)
    const [listaAgendamentos, setlistaAgendamentos] = React.useState([])

    useEffect(() => {
        Clear();
        setSession(getSessionCookie());

    }, [showmodal]);

    const Clear = () => {
        setValue("cpfcliente", "");
        setValue("nomecliente", "");
        setValue("emailcliente", "");
        setValue("obs", "");
        setValue("duracao", "");
        setValue("profissional", "");
        setprofissional("");
        setvenda("");
        setValue("venda", "");
        setValue("servico", "");
        setValue("qtdServico", "0");
        setValue("servicoSelecionado", "");
        setValue("data", "");
        setValue("hora", "");
        setservico("");
        setetapa(0);
        setlistaAgendamentos([]);
        setCountServico(0);
        setlstSelectVendas([]);
        setlistSelectServico([]);
        set_lst_profissional([]);

        setqtdAgendamento([]);

        setNotification(false);
        setdisabledEmail(false);

    }

    // array para selecionar o profisisonal de cada agendamento
    const [loading_profissionais, set_loading_profissionais] = React.useState(false);
    const [lst_profissional, set_lst_profissional] = React.useState([]);
    const alteracao_profissional = (item_alterado, key) => {

        var _lst_profissional = lst_profissional;
        var _listSelectProfissional = listSelectProfissional;

        for (let index = 0; index < qtdAgendamento.length; index++) {
            if (index !== key && _lst_profissional[index] == null) {
                _lst_profissional.push({
                    title: "",
                    id: 0
                });
            }
            else if (index == key) {
                if (_lst_profissional[index] !== null)
                    _lst_profissional[index] =
                    {
                        title: item_alterado.title,
                        id: item_alterado.id
                    };
                else
                    _lst_profissional.push(
                        {
                            title: item_alterado.title,
                            id: item_alterado.id
                        }
                    );
            }
        }

        set_loading_profissionais(true);

        setTimeout(() => {
            set_loading_profissionais(false);
            set_lst_profissional(_lst_profissional);
        }, 10);
    }
    // array para selecionar a data de cada agendamento
    const [lst_data, set_lst_data] = React.useState([]);
    const alteracao_data = (item_alterado, key) => {
        let _lst_data = [];
        _lst_data = lst_data;

        for (let index = 0; index < qtdAgendamento.length; index++) {
            if (index !== key && _lst_data[index] == null) {
                _lst_data.push({
                    title: "",
                    id: 0
                });
            }
            else if (index == key) {
                if (_lst_data[index] !== null)
                    _lst_data[index] =
                    {
                        title: item_alterado.target.value,
                        id: item_alterado.id
                    };
                else
                    _lst_data.push(
                        {
                            title: item_alterado.target.value,
                            id: item_alterado.id
                        }
                    );
            }
        }

        set_lst_data(_lst_data);
    }
    // array para selecionar a hora de cada agendamento
    const [lst_hora, set_lst_hora] = React.useState([]);
    const alteracao_hora = (item_alterado, key) => {
        let _lst_hora = [];
        _lst_hora = lst_hora;

        for (let index = 0; index < qtdAgendamento.length; index++) {
            if (index !== key && _lst_hora[index] == null) {
                _lst_hora.push({
                    title: "",
                    id: 0
                });
            }
            else if (index == key) {
                if (_lst_hora[index] !== null)
                    _lst_hora[index] =
                    {
                        title: item_alterado.target.value,
                        id: item_alterado.id
                    };
                else
                    _lst_hora.push(
                        {
                            title: item_alterado.target.value,
                            id: item_alterado.id
                        }
                    );
            }
        }

        set_lst_hora(_lst_hora);
    }
    // array para selecionar a duracao de cada agendamento
    const [lst_duracao, set_lst_duracao] = React.useState([]);
    const alteracao_duracao = (item_alterado, key) => {
        let _lst_duracao = [];
        _lst_duracao = lst_duracao;

        for (let index = 0; index < qtdAgendamento.length; index++) {
            if (index !== key && _lst_duracao[index] == null) {
                _lst_duracao.push({
                    title: "",
                    id: 0
                });
            }
            else if (index == key) {
                if (_lst_duracao[index] !== null)
                    _lst_duracao[index] =
                    {
                        title: item_alterado.target.value,
                        id: item_alterado.id
                    };
                else
                    _lst_duracao.push(
                        {
                            title: item_alterado.target.value,
                            id: item_alterado.id
                        }
                    );
            }
        }

        set_lst_duracao(_lst_duracao);
    }



    const intialValues = {
        cliente: '',
        profissional: '',
        venda: '',
        servico: '',
        qtdServico: 0,
        idcliente: 0,
        servicoSelecionado: '',
        data: '',
        duracao: ''
    };

    const hideModal = () => {
        closemodal();
    }

    const [loadingValidateCPF, setloadingValidateCPF] = React.useState(false);
    //   const [vendasLoading, setvendasLoading] = React.useState(false);  
    const [lstSelectVendas, setlstSelectVendas] = React.useState([]);
    const [lstSelectVendaAgendamentos, setlstSelectVendaAgendamentos] = React.useState([]);
    const [disabledEmail, setdisabledEmail] = React.useState(false);

    const handleCPFChange = e => {
        let cpf = e.target.value;

        if(intialValues.idcliente != 0 || (intialValues.id != 0 && cpf === "")){
            setValue("idcliente", 0);
            Clear();
        }
        
        if (cpf === "")
            return;

        setloadingValidateCPF(true);
        const endPoint = "clientes/clientebycpfvenda/" + cpf + "/" + session.estabelecimentoId;
        UseGetApiSimple(endPoint, 0).then(result => {
            // retorno = 500 é exception especifica para cliente que está na LISTA NEGRA!
            if (result.status === 500) {
                showNotification(result.message, 'danger')
                setloadingValidateCPF(false);
                return false;
            }
            if (result.status !== 200) {
                setValue("idcliente", 0);
                setValue("nomecliente", "");
                setValue("emailcliente", "");
                setloadingValidateCPF(false);
                return false;
            }
            if (result.data) {
                setValue("idcliente", result.data.clienteId);
                setValue("nomecliente", result.data.nome);
                setValue("emailcliente", result.data.email);
                if (result.data.email != "" && result.data.email != null) {
                    setdisabledEmail(true);
                }
                else {
                    setdisabledEmail(false);
                }
                // consulta as vendas que eu tenho para esse cliente que possuem serviços para agendar
                let endPointVenda = "vendas/vendasAgendamento/" + session.estabelecimentoId + "/" + result.data.clienteId;
                UseGetApiSimple(endPointVenda, 0).then(result => {
                    if (result.status !== 200) {
                        showNotification(result.message, 'danger');
                        // setvendasLoading(false);
                        return false;
                    }

                    let lstVendaAgendamentos = [];
                    let lstVendas = [];
                    // Carrega a lista com TODAS AS VENDAS e agendamentos que tem pra fazer de cada venda
                    result.data.map(item => lstVendaAgendamentos.push({
                        vendaAgendamentoId: item.vendaAgendamentoId,
                        servicoId: item.servicoId,
                        vendaId: item.vendaId,
                        agendamentoId: item.agendamentoId,
                        servico: item.servico.descricao,
                        servicoDeletado: item.servico.deletado
                    }));
                    //Filtra pra pegar somente o id das vendas e não repetir na lista o mesmo id de venda
                    lstVendaAgendamentos.forEach(element => {

                        if (lstVendas.filter((v) => { return v.vendaId == element.vendaId }).length == 0) {
                            lstVendas.push(element);
                        }
                    });
                    //lista de vendas
                    setlstSelectVendas(lstVendas);
                    //lista com todos os agendamenos que tem para fazer de todas as vendas
                    setlstSelectVendaAgendamentos(lstVendaAgendamentos);
                });
            }
            setloadingValidateCPF(false);
        });
    }

    const [lstServicosAgentamentos, setlstServicosAgentamentos] = React.useState([]);
    //seleciona a venda
    const handleVendaChange = event => {
        let value = event
        setvenda(value);
        setValue("venda", value);

        let lstservicos = [];
        //pega o id e a descrição dos serviços que estão vinculados a essa venda pendentes de agendamento
        lstSelectVendaAgendamentos.map(item => {
            if (item.vendaId == value) {
                lstservicos.push({
                    servicoId: item.servicoId,
                    descricao: item.servico,
                    deletado: item.servicoDeletado
                });
            }
        });
        setlstServicosAgentamentos(lstservicos);

        let lstServicosDistinct = [];
        // preenche a nova lista lstServicosDistinct com os serviços porém sem descrições repetidas, 
        lstservicos.forEach(element => {

            if (lstServicosDistinct.filter((v) => { return v.descricao == element.descricao }).length == 0) {
                lstServicosDistinct.push(element);
            }
        });

        setlistSelectServico(lstServicosDistinct);


        // loadServicosbyProfissional(value)
        if (value !== "")
            clearError("venda");

        // setservico(null);
        // setValue("servico", null);
    };

    const [CountServico, setCountServico] = React.useState(0);
    const [qtdAgendamento, setqtdAgendamento] = React.useState([]);
    const [servico_selecionado_descricao, set_servico_selecionado_descricao] = React.useState("");
    const [servicoDeletado, setservicoDeletado] = React.useState(false);

    //seleciona o serviço 
    const handleServicoChange = event => {
        let value = event
        setservico(value);
        setValue("servico", value);
        if (value !== "")
            clearError("servico");

        let servicoQtd = 0;
        let servicoDesc = "";
        let servicoDeletado = false;
        // grava quantos agendamentos eu tenho na lista pra fazer desse mesmo serviço selecionado
        for (var i = 0; i < lstServicosAgentamentos.length; i++) {
            if (lstServicosAgentamentos[i].servicoId == value) {
                servicoQtd++;
                servicoDesc = lstServicosAgentamentos[i].descricao;
                servicoDeletado = lstServicosAgentamentos[i].deletado;
            }
        }
        setCountServico(servicoQtd);
        setservicoDeletado(servicoDeletado);

        setValue("qtdServico", servicoQtd);
        setValue("servicoSelecionado", servicoDesc);

        set_servico_selecionado_descricao(servicoDesc);
    };

    const onlyNumbers = (e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') };

    const [profissionaisLoading, setprofissionaisLoading] = React.useState(false);
    const validateStep0 = () => {
        let data = getValues();
        let retorno = true;

        if (venda == "") {
            retorno = false;
            setError("profissional", "required");
        }

        if (servico == "") {
            retorno = false;
            setError("servico", "required");
        }
        if (data.servicoSelecionado == "") {
            retorno = false;
            setError("servico", "required");
        }

        let _array = [];
        for (let index = 0; index < data.qtdServico; index++) {
            _array.push("");
        }

        setqtdAgendamento(_array);

        return retorno;
    }

    const handleEtapa = (number) => {
        if (number === 1) {
            if (!validateStep0())
                return;
        }

        setprofissionaisLoading(true);
        let endPointVenda = "profissionais/profissionaisbyservico/" + servico + "/" + session.estabelecimentoId;
        UseGetApiSimple(endPointVenda, 0).then(result => {
            if (result.status !== 200) {
                showNotification("Não encontrado nenhum profissional para o serviço selecionado", 'danger');
                setprofissionaisLoading(false);
                return false;
            }

            let lstProfissionais = [];
            result.data.map(item => {

                var p = {
                    id: item.profissionalId,
                    title: item.nome,
                }

                if (session && session.tipoPerfil === 2) {// Perfil Profissional só vê a agenda dele
                    if (item.usuarioId === session.id)
                        lstProfissionais.push(p);
                }
                else if (session && session.tipoPerfil !== 2) {
                    lstProfissionais.push(p);
                }
                else {
                    lstProfissionais.push(p);
                }

            });

            setlistSelectProfissional(lstProfissionais);
            setprofissionaisLoading(false);
            setlistaAgendamentos([]);
            return true;
        });

        setetapa(number);
    }

    const onSubmit = data => {

        for (let index = 0; index < qtdAgendamento.length; index++) {

            if (
                (lst_profissional[index] == null || lst_profissional[index].id == 0) ||
                (lst_data[index] == null || lst_data[index].title == "") ||
                (lst_hora[index] == null || lst_hora[index].title == "") ||
                (lst_duracao[index] == null || lst_duracao[index].title == "")
            ) {
                showNotification("Não foi possível realizar os agendamentos. <br /> Verifique as seguintes Pendências: <br /> <br /> Preencha todos os campos para salvar!", "warning");
                return false;
            }

        }

        let json_post = [];

        for (let index = 0; index < qtdAgendamento.length; index++) {
            json_post.push(
                {
                    agendamentoId: 0,
                    data: convertDate(lst_data[index].title),
                    horaInicio: lst_hora[index].title,
                    horaFim: "00:00:00",
                    tempoDuracao: parseInt(lst_duracao[index].title),
                    servicoId: data.servico,
                    clienteId: parseInt(data.idcliente),
                    emailcliente: data.emailcliente,
                    nomecliente: data.nomecliente,
                    cpfcliente: data.cpfcliente,
                    profissionalId: lst_profissional[index].id,
                    statusAgendamento: 0,
                    usuarioCadastroId: session.id,
                    estabelecimentoId: session.estabelecimentoId,
                    obs: venda//envia o id da venda na OBS para que possa dar baixa nos serviços dessa venda na tabela vendaAgendamentos
                }
            )
        }

        // console.log(json_post);
        // return

        let endPoint = 'agendamentos/saveagendamentoscontrato';
        setLoading(true);
        UsePostApi(endPoint, json_post).then(result => {
            if (result.status !== 201) {
                showNotification(result.message, 'danger');
                setLoading(false);
                return false;
            }


            setLoading(false);

            if (result.data.sucesso) {
                callback();
                setLoading(false);
                showNotification(result.data.mensagem, 'sucess');
                closemodal();
                return true;
            }
            else {
                var notify = result.data.mensagem;
                if (result.data.erros != null) {
                    result.data.erros.map((item) => {
                        notify += " <br /> <br /> " + item
                    });
                }
                showNotification(notify, "warning");
            }

        });

    };

    return (
        <CardBody>

            <Snackbar
                place="tr"
                color={colorNotification}
                message={mensagemNotification}
                open={notification}
                closeNotification={() => setNotification(false)}
                close
            />

            {loading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <label>{t('label.loading')}...</label>
                        <CircularProgress />
                    </div>
                </div>
            }


            <form onSubmit={handleSubmit(onSubmit)}>
                <GridContainer>
                    <GridItem xs={12} sm={6} md={6}>
                        <h3>{t('agenda.contract_scheduling')}</h3>
                        <label>{t('agenda.please_enter_data')}.</label>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                        <Card>
                            <CardBody className={classesHeader.cardHeaderProcesso}>
                                <GridContainer>
                                    <GridItem xs={6} sm={6} md={6} className={classesHeader.gridHeader}>
                                        <div className={classesHeader.boxProcess}>
                                            <div className={classesHeader.boxItem}>
                                                <div className={classesHeader.iconItem + " " + classesHeader.iconCheck}>
                                                    <Check className={classesHeader.icoSize} />
                                                </div>
                                                {t('avaliation.contractt_data')}
                                            </div>
                                            <div className={etapa === 0 ? classesHeader.lineProcessRight + " " + classesHeader.lineLight : classesHeader.lineProcessRight + " " + classesHeader.lineDark} ></div>
                                        </div>
                                    </GridItem>
                                    <GridItem xs={6} sm={6} md={6} className={classesHeader.gridHeader}>
                                        <div className={classesHeader.boxProcess}>
                                            <div className={classesHeader.boxItem}>
                                                <div className={etapa < 1 ? classesHeader.iconItem + " " + classesHeader.iconUnCheck : classesHeader.iconItem + " " + classesHeader.iconCheck}>
                                                    <Check className={etapa < 1 ? classesHeader.noneCheck : classesHeader.icoSize} />
                                                </div>
                                                {t('agenda.appointments')}
                                            </div>
                                            <div className={etapa < 1 ? classesHeader.lineProcessLeft + " " + classesHeader.lineLight : classesHeader.lineProcessLeft + " " + classesHeader.lineDark} ></div>
                                            <div className={etapa >= 1 ? classesHeader.lineProcessRight + " " + classesHeader.lineDark : classesHeader.lineProcessRight + " " + classesHeader.lineLight} ></div>
                                        </div>
                                    </GridItem>
                                </GridContainer>
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
                <br />
                <div style={{ display: etapa === 0 ? "block" : "none" }}>
                    <GridContainer>
                        <input className={classes.hidden} defaultValue={intialValues.idcliente} name="idcliente" ref={register} />
                        <GridItem xs={12} sm={4} md={4}>
                            <FormControl fullWidth className={classes.formControl}>
                                <TextField
                                    error={errors.cpf ? true : false}
                                    label="CPF"
                                    variant="outlined"
                                    onBlur={handleCPFChange}
                                    inputRef={register({ required: false })}
                                    name="cpfcliente"
                                    defaultValue={intialValues.cpf}
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        inputComponent: MaskCPF,
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                {loadingValidateCPF && <LoadingIcon className="rotate" />}
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                {errors.cpf &&
                                    <FormHelperText className={classes.labelRootError}>
                                        <span>{errors.cpf.message} </span>
                                    </FormHelperText>}
                            </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={8} md={8}>
                            <FormControl fullWidth className={classes.formControl}>
                                <TextField
                                    error={errors.emailcliente ? true : false}
                                    label={t('label.client_email') + " *"}
                                    variant="outlined"
                                    inputRef={register({
                                        required: "E-mail é Obrigatório",
                                        pattern: {
                                            value: /^\S+@\S+$/i,
                                            message: t('label.invalid_email')
                                        },
                                        maxLength: {
                                            value: 50,
                                            message: t('label.enter_a_maximum_of_50_characters')
                                        }
                                    })}
                                    name="emailcliente"
                                    defaultValue={intialValues.cliente}
                                    disabled={disabledEmail}
                                    InputLabelProps={{ shrink: true }}
                                />
                                <FormHelperText className={classes.labelRootError}>
                                    {errors.emailcliente && <span> {errors.emailcliente.message} </span>}
                                </FormHelperText>
                            </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                            <FormControl fullWidth className={classes.formControl}>
                                <TextField
                                    error={errors.nomecliente ? true : false}
                                    label={t('label.client_name') + " *"}
                                    variant="outlined"
                                    inputRef={register({ required: true })}
                                    name="nomecliente"
                                    defaultValue={intialValues.nomecliente}
                                    disabled={true}
                                    InputLabelProps={{ shrink: true }}
                                    inputProps={{ maxLength: 100 }}
                                />
                                <FormHelperText className={classes.labelRootError}>
                                    {errors.nomecliente && <span>{t('label.required')}</span>}
                                </FormHelperText>
                            </FormControl>
                        </GridItem>
                    </GridContainer>
                    <GridContainer>
                        <GridItem xs={12} sm={5} md={5}>
                            <FormControl fullWidth className={classes.formControl}>
                                <label className={errors.venda ? "select__label select__label_error" : "select__label"}>
                                    {t('label.contract')} *
                                </label>
                                <Select
                                    classNamePrefix="select"
                                    styles={ValidSelect(errors.venda ? true : false)}
                                    isSearchable={true}
                                    name="venda"
                                    placeholder="Selecione..."
                                    options={lstSelectVendas}
                                    value={lstSelectVendas.filter(({ vendaId }) => vendaId === venda)}
                                    getOptionLabel={({ vendaId }) => vendaId}
                                    getOptionValue={({ vendaId }) => vendaId}
                                    onChange={(value) => handleVendaChange(value.vendaId !== null ? value.vendaId : "")}

                                    ref={() => register(
                                        { name: "venda" },
                                        { required: true })
                                    }
                                />
                                <FormHelperText className={classes.labelRootError}>
                                    {errors.venda && <span> {t('label.required')} </span>}
                                </FormHelperText>
                            </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={5} md={5}>
                            <FormControl fullWidth className={classes.formControl}>
                                <label className={errors.servico ? "select__label select__label_error" : "select__label"}>{t('label.service')}  *</label>
                                <Select
                                    classNamePrefix="select"
                                    styles={ValidSelect(errors.servico ? true : false)}
                                    isSearchable={true}
                                    name="servico"
                                    placeholder="Selecione..."
                                    options={listSelectServico}
                                    value={listSelectServico.filter(({ servicoId }) => servicoId === servico)}
                                    getOptionLabel={({ descricao }) => descricao}
                                    getOptionValue={({ servicoId }) => servicoId}
                                    onChange={(value) => handleServicoChange(value.servicoId !== null ? value.servicoId : "")}

                                    ref={() => register(
                                        { name: "servico" },
                                        { required: true })
                                    }
                                />
                                <FormHelperText className={classes.labelRootError}>
                                    {errors.servico && <span> {t('label.required')} </span>}
                                </FormHelperText>
                            </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={2} md={2}>
                            <FormControl fullWidth className={classes.formControl}>
                                <TextField
                                    error={errors.qtdServico ? true : false}
                                    label={t("agenda.qtd_services") + " *"}
                                    variant="outlined"
                                    inputRef={register({ required: true })}
                                    name="qtdServico"
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{ inputProps: { min: 1, max: CountServico } }}
                                    type="number"
                                    defaultValue="0"
                                />
                                <FormHelperText className={classes.labelRootError}>
                                    {errors.qtdServico && <span>{errors.qtdServico.message} </span>}
                                </FormHelperText>
                            </FormControl>
                        </GridItem>
                    </GridContainer>
                    <GridContainer justify="center">
                        <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                            <div className={classes.textCenter}>
                                <Button onClick={hideModal} color="transparent" className={classes.updateProfileButton}>
                                    {t('button.cancel')}
                                </Button>
                                <Button type="button" onClick={() => handleEtapa(1)} color="primary" className={classes.updateProfileButton}>
                                    {t('label.advance')}  {loading && <div> ... {t('label.loading')}</div>}
                                </Button>
                            </div>
                        </GridItem>
                    </GridContainer>
                </div>

                <div style={{ display: etapa === 1 ? "block" : "none" }}>

                    <h5> <strong> {t('agenda.selected_service') + ":"} </strong> </h5>
                    {servicoDeletado ? <h5><strong class="text-danger">{servico_selecionado_descricao + "(DELETADO)"}</strong></h5> : <h5><strong>{servico_selecionado_descricao}</strong></h5>}
                    <hr />

                    {
                        qtdAgendamento != null && qtdAgendamento.map((f, key) => {
                            return <div>

                                <GridContainer>

                                    {loading_profissionais && ""}

                                    <GridItem xs={1} sm={1} md={1} className={classes.textCenter}>
                                        <strong>{key + 1}º</strong>
                                    </GridItem>

                                    <GridItem xs={12} sm={5} md={5}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <label className={errors.profissional ? "select__label select__label_error" : "select__label"}>
                                                {t('label.professional')} *
                                            </label>
                                            <Select
                                                classNamePrefix="select"
                                                isSearchable={true}
                                                placeholder="Selecione..."
                                                options={listSelectProfissional}
                                                value={listSelectProfissional.filter(({ id }) => id === (lst_profissional[key] == null ? 0 : lst_profissional[key].id))}
                                                onChange={(value) => alteracao_profissional(value, key)}
                                                getOptionLabel={({ title }) => title}
                                                getOptionValue={({ id }) => id}
                                            />
                                        </FormControl>
                                    </GridItem>

                                    <GridItem xs={4} sm={3} md={2}>
                                        <FormControl fullWidth >
                                            <TextField
                                                error={errors.data ? true : false}
                                                label={t('label.date') + " *"}
                                                variant="outlined"
                                                name="data"
                                                onChange={(value) => alteracao_data(value, key)}
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    inputComponent: MaskDate,
                                                }}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.data && <span>{errors.data.message}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>

                                    <GridItem xs={4} sm={3} md={2}>
                                        <FormControl fullWidth >
                                            <TextField
                                                error={errors.hora ? true : false}
                                                label={t('agenda.start_time') + " *"}
                                                variant="outlined"
                                                name="hora"
                                                onChange={(value) => alteracao_hora(value, key)}
                                                defaultValue={""}
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    inputComponent: MaskTime,
                                                }}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.hora && <span>Obrigatório</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>

                                    <GridItem xs={12} sm={2} md={2}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                error={errors.duracao ? true : false}
                                                label={t('label.duration_minutes') + " *"}
                                                variant="outlined"
                                                name="duracao"
                                                onChange={(value) => alteracao_duracao(value, key)}
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ maxLength: 3 }}
                                                onInput={(e) => onlyNumbers(e)}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.duracao && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>

                                </GridContainer>

                                <hr></hr>
                            </div>
                        })}
                    <GridContainer justify="center">
                        <br /><br />
                        <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                            <div className={classes.textCenter}>
                                <Button onClick={() => handleEtapa(0)} color="transparent" className={classes.updateProfileButton}>
                                    {t('label.return')}
                                </Button>
                                <Button type="submit" color="primary" className={classes.updateProfileButton}>
                                    {t('button.to_save')}  {loading && <div> ... {t('label.loading')}</div>}
                                </Button>
                            </div>
                        </GridItem>
                    </GridContainer>
                </div>
            </form>
        </CardBody>
    );
}
